if (!customElements.get('bv-product-upsell')) {
  class BvProductUpsell extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-bv-upsell-list]');
      this.section = this.closest('.bv-upsell');
      this.url = this.dataset.url;

      if (!this.list || !this.url) return;

      if (this.list.children.length > 0) {
        this.section?.classList.remove('bv-upsell--loading');
        this.bindVariantSelects();
        return;
      }

      this.fetchRecommendations();
    }

    fetchRecommendations() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const list = html.querySelector('[data-bv-upsell-list]');

          if (!list || !list.innerHTML.trim()) {
            this.section?.classList.add('bv-upsell--empty');
            this.section?.classList.remove('bv-upsell--loading');
            return;
          }

          this.list.innerHTML = list.innerHTML;
          this.section?.classList.remove('bv-upsell--loading', 'bv-upsell--empty');
          this.bindVariantSelects();
        })
        .catch(() => {
          this.section?.classList.add('bv-upsell--empty');
          this.section?.classList.remove('bv-upsell--loading');
        });
    }

    bindVariantSelects() {
      this.querySelectorAll('[data-bv-upsell-variant]').forEach((select) => {
        if (select.dataset.bound === 'true') return;
        select.dataset.bound = 'true';

        select.addEventListener('change', () => {
          const card = select.closest('.bv-upsell-card');
          const input = card?.querySelector('input[name="id"]');
          if (input) input.value = select.value;
        });
      });
    }
  }

  customElements.define('bv-product-upsell', BvProductUpsell);
}
